import { useEffect, useState } from 'react';

const load = (src: string) =>
  new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = img.onerror = () => resolve();
    img.src = src;
    if (img.complete) resolve();
  });

/**
 * Vrai quand la première image est chargée (ou après `timeout` ms, pour ne jamais bloquer la page).
 * Les images suivantes sont préchargées ensuite, pour que les transitions du carrousel ne montrent pas de vide.
 */
export function useFirstImageReady(urls: string[], timeout = 4000): boolean {
  const [ready, setReady] = useState(false);
  const key = urls.join('|');

  useEffect(() => {
    if (urls.length === 0) return;
    let alive = true;
    const done = () => alive && setReady(true);
    const timer = window.setTimeout(done, timeout);
    load(urls[0]).then(() => {
      window.clearTimeout(timer);
      done();
      urls.slice(1).forEach((u) => void load(u));
    });
    return () => { alive = false; window.clearTimeout(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, timeout]);

  return ready;
}
